<template>
    <div class="auth-layout-wrap flex-row">
        <b-card class="card-adjustment shadow-lg mr-3">
            <b-row>
                <b-col>
                    <div class="text-center mb-4">
                        <img src="/static/img/logo/medium.png" />
                    </div>
                    <h1 class="mb-3 text-18">Login</h1>
                    <b-form @submit.prevent="formSubmit">
                        <b-form-group
                            label="Email"
                            class="text-14"
                        >
                            <b-form-input
                                class="form-control-rounded"
                                type="text"
                                v-model="email"
                                email
                                required
                            ></b-form-input>
                        </b-form-group>

                        <b-form-group label="Senha" class="text-14">
                            <b-form-input
                                class="form-control-rounded"
                                type="password"
                                v-model="password"
                            ></b-form-input>
                        </b-form-group>
                        <b-button
                            type="submit"
                            tag="button"
                            class="btn-rounded btn-block mt-4 text-14"
                            variant="primary"
                        >
                            Entrar
                        </b-button>
                    </b-form>

                    <div class="mt-3 text-center">
                        <router-link
                            to="forgot"
                            tag="a"
                            class="text-muted text-14"
                        >
                            <u>Esqueceu a senha?</u>
                        </router-link>
                    </div>
                </b-col>

                <!-- <b-col md="6" class="text-center">
                    <div class="pr-3 auth-right">
                        <a
                            class="btn btn-rounded btn-outline-primary btn-outline-google btn-block btn-icon-text"
                            @click="loginWithGoogle"
                        >
                            <i class="i-Google-Plus"></i> Logar com Google
                        </a>
                    </div>
                </b-col> -->
            </b-row>
        </b-card>
        <div class="ml-3 mt-5 text-20 align-items-end">
            <p class="mb-1 text-muted">
                Ainda não possui uma conta?
            </p>
            <a class="typo_link text-primary t-font-boldest" href="/newaccount.html" >Crie uma agora</a>
        </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data () {
        return {
            email: '',
            password: '',
            userId: '',
        }
    },
    computed: {
        validation () {
            return this.userId.length > 4 && this.userId.length < 13
        },
    },
    methods: {
        ...mapActions(['login']),
        formSubmit () {
            this.$store
                .dispatch('auth/loginWithEmailAndPassword', { email: this.email, password: this.password })
                .catch(err => {
                    if (['auth/user-not-found', 'auth/wrong-password'].includes(err.code)) {
                        this.makeToast('Ops!', 'danger', 'Usuário ou senha incorretos')
                    }
                })
        },
        makeToast (title, variant = null, msg) {
            this.$bvToast.toast(msg, {
                title: title,
                variant: variant,
                solid: true,
            })
        },
        loginWithGoogle () {
            this.$store
                .dispatch('auth/loginWithGoogle')
                .then(() => {
                    this.$router.push('/happiness/dashboard')
                })
                .catch(err => {
                    console.log('%c%s:%i', 'color: darkgreen', 'Signin.vue', 133, err)
                })
        },
    },
    watch: {
        error (val) {
            if (val != null) {
                this.makeToast('warning', val.message)
            }
        },
    },
}
</script>

<style>
.spinner.sm {
    height: 2em;
    width: 2em;
}

.card-adjustment {
    min-width: 420px;
    max-width: 660px;
}
</style>
